import * as faceapi from 'face-api.js'

// Model URLs - these are the official face-api.js models
const MODEL_URL = 'https://justadudewhohacks.github.io/face-api.js/models'

// Model loading configuration
const modelConfig = {
  faceDetection: {
    url: `${MODEL_URL}/ssdMobilenetv1`,
    name: 'Face Detection Model'
  },
  faceLandmarks: {
    url: `${MODEL_URL}/face_landmark_68`,
    name: 'Face Landmarks Model'
  },
  faceExpressions: {
    url: `${MODEL_URL}/face_expression`,
    name: 'Face Expressions Model'
  }
}

// Cache for loaded models to prevent re-downloading
let modelsLoaded = false
let loadingPromise = null

/**
 * Load all required face-api.js models
 * @returns {Promise} Promise that resolves when all models are loaded
 */
export const loadFaceApiModels = async () => {
  // Return cached promise if already loading
  if (loadingPromise) {
    return loadingPromise
  }

  // Return immediately if models are already loaded
  if (modelsLoaded) {
    return Promise.resolve()
  }

  loadingPromise = new Promise(async (resolve, reject) => {
    try {
      console.log('Starting face-api.js model loading...')

      // Load models in parallel for better performance
      const loadPromises = [
        faceapi.nets.ssdMobilenetv1.loadFromUri(modelConfig.faceDetection.url),
        faceapi.nets.faceLandmark68Net.loadFromUri(modelConfig.faceLandmarks.url),
        faceapi.nets.faceExpressionNet.loadFromUri(modelConfig.faceExpressions.url)
      ]

      // Wait for all models to load
      await Promise.all(loadPromises)

      console.log('All face-api.js models loaded successfully')
      modelsLoaded = true
      resolve()
    } catch (error) {
      console.error('Error loading face-api.js models:', error)
      modelsLoaded = false
      loadingPromise = null
      reject(new Error(`Failed to load AI models: ${error.message}`))
    }
  })

  return loadingPromise
}

/**
 * Check if models are loaded
 * @returns {boolean} True if models are loaded
 */
export const areModelsLoaded = () => {
  return modelsLoaded
}

/**
 * Reset model loading state (useful for testing or re-initialization)
 */
export const resetModelLoading = () => {
  modelsLoaded = false
  loadingPromise = null
}

/**
 * Get model loading progress (for future implementation)
 * @returns {number} Loading progress percentage (0-100)
 */
export const getModelLoadingProgress = () => {
  // This could be enhanced to track actual download progress
  // For now, return a simple indicator
  return modelsLoaded ? 100 : 0
} 